import React, { useState } from 'react';
import { styled } from 'styled-components';
import { ButtonLink, H2, P1 } from '../../styles/textTags';
import { BREAKPOINTS, COLORS } from '../../styles/variables';
import ArrowButton from '../Shared/ArrowButton';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../features/queries/config';

const Card = ({ data }) => {
  const [isActive, setIsActive] = useState(false);

  const navigate = useNavigate();

  const navigateToEvent = () => {
    navigate(`/event/${data.Slug}`);
  };

  const bgImageUrl = BASE_URL + data.Bg_image.data.attributes.formats.medium.url;

  const ticketLink = data.Buy_ticket || '';

  return (
    <CardWr
      $isActive={isActive}
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}
      $bgImage={bgImageUrl}
    >
      <Blur $isActive={isActive} />

      <Title $isActive={isActive}>{data.Title}</Title>
      <Content $isActive={isActive}>
        <ArrowButtonWr $isActive={isActive}>
          <ArrowButton onClick={navigateToEvent} />
        </ArrowButtonWr>

        <ContentTitle>{data.Title}</ContentTitle>
        <P1>{data.About_the_performance}</P1>
        {ticketLink && (
          <ButtonLink href={ticketLink} target='_blank'>
            Купить билет
          </ButtonLink>
        )}
      </Content>
    </CardWr>
  );
};

const CardWr = styled.div`
  display: flex;
  align-items: end;

  position: relative;
  overflow: hidden;

  height: 390px;

  padding: 32px;

  background-image: url(${({ $bgImage }) => ($bgImage ? $bgImage : '')});

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 24px;

  color: ${COLORS.white};

  @media ${BREAKPOINTS.laptop} {
    height: 27.08vw;
    padding: 2.22vw;
    border-radius: 1.67vw;
  }

  @media ${BREAKPOINTS.mobile} {
    height: 78.33vw;
    padding: 4.17vw;
    border-radius: 5vw;
  }
`;

const Blur = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 0;
  border-radius: 24px;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(${({ $isActive }) => ($isActive ? '4px' : '0')});
  -webkit-backdrop-filter: blur(${({ $isActive }) => ($isActive ? '4px' : '0')});
  background-color: rgba(${({ $isActive }) => ($isActive ? '0, 0, 0, 0.3' : '0')});
  transition: backdrop-filter 0.5s 0.1s, -webkit-backdrop-filter 0.5s 0.1s,
    background-color 0.5s 0.1s;

  @media ${BREAKPOINTS.laptop} {
    border-radius: 1.67vw;
    backdrop-filter: blur(${({ $isActive }) => ($isActive ? '0.28vw' : '0')});
    -webkit-backdrop-filter: blur(${({ $isActive }) => ($isActive ? '0.28vw' : '0')});
  }

  @media ${BREAKPOINTS.mobile} {
    border-radius: 5vw;
    backdrop-filter: blur(${({ $isActive }) => ($isActive ? '0.83vw' : '0')});
    -webkit-backdrop-filter: blur(${({ $isActive }) => ($isActive ? '0.83vw' : '0')});
  }
`;

const Title = styled(H2)`
  opacity: ${({ $isActive }) => ($isActive ? '0' : '1')};
  transition: opacity 0.3s;
  transition-delay: ${({ $isActive }) => ($isActive ? '0.2s' : '0.5s')};

  text-align: start;
  max-width: 80%;
  padding: 7px 50px;
  border-radius: 60px;

  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);

  @media ${BREAKPOINTS.laptop} {
    padding: 0.49vw 3.47vw;
    border-radius: 4.17vw;

    backdrop-filter: blur(2.08vw);
    -webkit-backdrop-filter: blur(2.08vw);
  }

  @media ${BREAKPOINTS.mobile} {
    padding: 1.25vw 5.83vw;
    border-radius: 6.67vw;

    backdrop-filter: blur(6.25vw);
    -webkit-backdrop-filter: blur(6.25vw);
  }
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  padding: 32px;
  padding-top: 100px;

  transform: translateY(${({ $isActive }) => ($isActive ? '0' : '100%')});
  opacity: ${({ $isActive }) => ($isActive ? '1' : '0')};

  transition: transform ${({ $isActive }) => ($isActive ? '0.4s 0.3s' : '0.4s 0.1s')},
    opacity ${({ $isActive }) => ($isActive ? '0.3s 0.2s' : '0.3s 0.1s')};

  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: end;

  ${P1} {
    margin-bottom: 36px;
    max-width: 90%;

    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media ${BREAKPOINTS.laptop} {
    padding: 2.22vw;
    padding-top: 7.14vw;
    ${P1} {
      margin-bottom: 2.5vw;
    }
  }

  @media ${BREAKPOINTS.mobile} {
    padding: 4.17vw;
    padding-top: 15.21vw;
    ${P1} {
      max-width: 100%;
      margin-bottom: 6.25vw;
    }
  }
`;

const ContentTitle = styled(H2)`
  text-align: start;
  max-width: 80%;
  margin-bottom: 12px;

  @media ${BREAKPOINTS.laptop} {
    margin-bottom: 0.83vw;
  }

  @media ${BREAKPOINTS.mobile} {
    margin-bottom: 2.5vw;
  }
`;

const ArrowButtonWr = styled.div`
  position: absolute;
  right: 32px;
  top: 32px;

  transform: translateX(${({ $isActive }) => ($isActive ? '0' : '200%')});
  transition: 0.3s 0.5s;
  @media ${BREAKPOINTS.laptop} {
    right: 2.22vw;
    top: 2.22vw;
  }

  @media ${BREAKPOINTS.mobile} {
    right: 4.17vw;
    top: 4.17vw;
  }
`;

export default Card;
